export var buttonWidths = {
    xsmall: '12px',
    small: '16px',
    medium: '20px',
    large: '28px',
    xlarge: '44px',
};
